module.exports = __webpack_public_path__ + "static/media/usdc-bnb.2cd58591.svg";